import { Container, ContainerGutter, styled, Text, TokenTextAppearance, TextTag } from '@volkswagen-onehub/components-core';
import React from 'react';

interface FeaturesInterface {
    features: string[] | null | undefined
}

const TextBordered = styled(Text)`
    border-bottom: 1px solid #f6f7f8;
`;

const FeatureSpecs = ({ features }: React.PropsWithChildren<FeaturesInterface>) => {

    return <Container
        gutter={ContainerGutter.static200}
        wrap="always">
        {
            features && features.map((feature, i) => {
              const key = `feature-${i}`
                    return <TextBordered tag={TextTag.span} appearance={TokenTextAppearance.copy200} key={key}>{feature}</TextBordered>;
            })
        }
    </Container>
}

export default FeatureSpecs;
